import AutomationProvider from 'automations/providers/automationProvider';

export default function withAutomationProvider<T extends object>(
  Component: React.ComponentType<T>,
) {
  return function WithAutomationProvider(props: T) {
    return (
      <AutomationProvider>
        <Component {...props} />
      </AutomationProvider>
    );
  };
}
